import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "ag-grid-evrideo-video-name-cell",
  template: `<img
      [src]="thumb"
      width="48px"
      [title]="name || 'thumbnail'"
    /><span *ngIf="name">{{ name }}</span>`,
  styleUrls: ["./ag-grid-evrideo-video-name-cell.component.scss"],
})
export class AgGridEvrideoVideoNameCellComponent
  implements ICellRendererAngularComp
{
  name!: string;
  thumb!: string;

  agInit(params: ICellRendererParams): void {
    this.updateDisplayValue(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateDisplayValue(params);
    return true;
  }

  private updateDisplayValue(params: any): void {
    if (!params.data) {
      return;
    }
    this.thumb = params.videoThumb(params.data);
    this.name = params.videoName(params.data);
    if (!this.thumb) {
      this.thumb = "/assets/icons/loader-dots.svg";
    }
  }
}
